import { useContext, useRef } from 'react';
import ArrowLeft from '../../../assets/icons/ArrowLeft';
import ArrowRight from '../../../assets/icons/ArrowRight';
import Button from '../../../ui/Button';
import FlipCard from '../../../ui/FlipCard';
import Heading from '../../../ui/Heading';
import WhiteCard from '../../../ui/WhiteCard';
import emptyProjectIc from "../../../assets/emptyProcetIc.png"
import emptyContributorIc from "../../../assets/emptyContributorIc.png"
import { ProfileContext } from '../../../contexts/ProfileContext';
import NoDataAvailable from '../../../ui/NoDataAvailable';
import MintRequestedCertificate from './MintRequestedFront';
import MintRequestedBack from './MintRequestedBack';
import UnclaimedCard from '../unclaimed/UnclaimedCard';
import FlipCardProject from '../../../ui/FlipCardProject';
import EmptyProjectIc from '../../../ui/EmptyProjectIc';
import EmptyContributorIc from '../../../ui/EmptyContributorIc';
import MintedProject from '../minted/MintedProject';
import MintedCard from '../minted/MintedCard';

function AllMintRequested() {
    const { state } = useContext(ProfileContext);
    const mintRequestedIcs = state.filter((ic) => ic.status === 'MINT_REQUESTED' || ic.status === 'MINTING');
    const scrollCards = useRef();
    function scrollR() {
        scrollCards.current.scrollBy({
            left: 334,
            behavior: 'smooth',
        });
    }
    function scrollL() {
        scrollCards.current.scrollBy({
            left: -334,
            behavior: 'smooth',
        });
    }

    console.log(mintRequestedIcs, 'ye mint requested ics h ');

    return (
        <div className="mt-8">
            <Heading className={`text-textGrayHeading leading-10`} type={'medium'}>
                Mint Requested
            </Heading>
            <div className="relative">
                <div
                    verticalMargin=""
                    ref={scrollCards}
                    className="  flex items-center overflow-auto   scrollableCards"
                >
                    {mintRequestedIcs.length > 0 ? (
                        mintRequestedIcs.map((ic) => {

                        return     ic?.projectId
                                    ? <EmptyProjectIc
                                    width="w-[39.8125rem]"
                                   height="h-[25.625rem]"
                                    fixW="w-[39.8125rem]"
                                    key={ic.id + ic.status}
                                    image={emptyProjectIc}
                                    ic={ic}
                                    FrontCard={MintedProject}
                                    />    : 

                             (
           
                                <EmptyContributorIc
                                    width="w-[346px]"
                                    height="h-[25.625rem]"
                                    fixW="w-[346px]"
                                    key={ic?.id + ic?.status}
                                    image={ic?.image ? ic.image : emptyContributorIc}
                                    ic={ic}
                                    FrontCard={ic?.image ? MintRequestedCertificate : MintedCard}
                                />
                            );
                        })
                    ) : (
                        <div className="flex w-full items-center justify-center">
                            <NoDataAvailable marginTop="mt-3" />
                        </div>
                    )}
                </div>

                <Button
                    radius="rounded-full"
                    onClick={scrollL}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -left-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowLeft fillColor="#606060" />
                </Button>

                <Button
                    radius="rounded-full"
                    onClick={scrollR}
                    className="bg-[#EAEAEA] absolute top-[50%] translate-y-[-50%]  -right-[3.15rem] "
                    variant="tertiary"
                    size="circle"
                >
                    <ArrowRight fillColor={'#606060'} />
                </Button>
            </div>
        </div>
    );
}

export default AllMintRequested;
